<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="80%">
    <template v-slot:title>Itinerary Comps</template>

    <v-row>
      <v-col>
        <v-card outlined>
          <v-data-table :items="items" :headers="headers">
            <template v-slot:item.type="{ item }">
              <v-icon>{{
                item.type == "pax" ? "mdi-account" : "mdi-format-list-numbered"
              }}</v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <default-list-actions
                :item="item"
                hide-view
                @deleteItem="onDeleteItem"
                @editItem="onEditItem"
              ></default-list-actions>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <template v-slot:actions>
      <v-btn @click="onAddCompsClick">
        <v-icon left>mdi-plus-circle</v-icon>Add
      </v-btn>
      <v-btn color="primary" @click="onSave">Save & Apply </v-btn>
    </template>
    <itinerary-comp-dialog
      :show="showCompDialog"
      @close="showCompDialog = false"
      v-model="selectedItem"
      :suppliers="suppliers"
      :services="services"
      @input="onSaveComp"
      :iti-items="itiItems"
    />
    <div v-if="debug">
      <code>{{ value }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog.vue";
import DefaultListActions from "../../../shared/DefaultListActions.vue";
import ItineraryCompDialog from "./ItineraryCompDialog.vue";
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    itiItems: {
      type: Array,
      default: () => [],
    },
  },

  components: { BasicDialog, DefaultListActions, ItineraryCompDialog },

  data() {
    return {
      debug: false,
      items: this.value ? [...this.value.map(this.addType)] : [],
      showCompDialog: false,
      selectedItem: null,
      headers: [
        {
          text: "Supplier",
          value: "supplier.name",
          name: "supplier",
        },
        {
          text: "Pax From",
          value: "paxFrom",
          name: "paxFrom",
        },
        {
          text: "Pax To",
          value: "paxTo",
          name: "paxTo",
        },
        {
          text: "Type",
          value: "type",
          name: "type",
        },
        {
          text: "Comp Units/Pax",
          value: "free",
          name: "free",
        },
        {
          text: "Pass Comp Units/Pax",
          value: "pass",
          name: "pass",
        },

        {
          text: "Comp Service",
          value: "service.name",
          name: "service",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
    };
  },

  watch: {
    value(newVal) {
      this.items = [...newVal.map(this.addType)];
    },
  },

  computed: {
    suppliers() {
      return this.itiItems.reduce((supps, item) => {
        if (supps.map((s) => s.id).indexOf(item.supplierId) == -1) {
          supps.push({ id: item.supplierId, name: item.supplierName });
        }
        return supps;
      }, []);
    },
    services() {
      return this.itiItems.reduce((supps, item) => {
        if (supps.map((s) => s.id).indexOf(item.serviceId) == -1) {
          supps.push({
            id: item.serviceId,
            name: item.serviceName,
            supplierId: item.supplierId,
          });
        }
        return supps;
      }, []);
    },
  },

  methods: {
    addType(item) {
      //console.log("adding type to: ", item);
      const itiService = this.itiItems.find(
        (itiItem) => itiItem.serviceId == item.serviceId
      );
      const type =
        itiService && itiService.pricing && itiService.pricing.itemBased
          ? "qty"
          : "pax";
      return { type, ...item };
    },
    onAddCompsClick() {
      this.selectedItem = null;
      this.showCompDialog = true;
    },
    onSave() {
      this.$emit("input", [...this.items]);
    },
    onEditItem(item) {
      this.selectedItem = item;
      this.showCompDialog = true;
    },
    onDeleteItem(item) {
      this.items = [...this.items.filter((i) => i.id != item.id)];
    },
    onSaveComp(payload) {
      this.showCompDialog = false;
      const index = this.items.findIndex((item) => item.id == payload.id);
      if (index > -1) {
        Object.assign(this.items[index], { ...payload });
      } else {
        this.items.push(payload);
      }
      this.items = this.items.map(this.addType);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItineraryCompsDialog.vue